import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-melilux-bg text-melilux-cream/60 font-sans text-xs tracking-[0.3em] uppercase">
        Loading
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
